import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import './index.css';
import { useDocTitle } from './hooks/useDocTitle';
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {

  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: false, // Animate every time element comes into view
        duration: 800, // Slightly faster, smoother animations
        easing: 'ease-out-cubic',
        offset: 100, // Trigger animations 100px before element enters viewport
        delay: 0, // Base delay
        anchorPlacement: 'top-bottom', // When top of element hits bottom of viewport
        disable: window.matchMedia('(prefers-reduced-motion: reduce)').matches, // Respect user preferences
      });
    }

    window.addEventListener('load', () => {
      aos_init();
    });
  }, []);

  useDocTitle("Normandy Farm");

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
